// @generated source--
// scripts/generate-bits/file-generators/component-story-map.generator.ts

export const directiveStoryMap: {
  [name: string]: {
    path: string;
    tags: string[];
    internalOnly: boolean;
    stories: string[];
    description: string;
  };
} = {
  'animate-on-scroll': {
    path: '',
    tags: ['animations'],
    internalOnly: false,
    stories: ['default', 'reset'],
    description: 'Animates specific elements once it is visible in the view.',
  },
  'auto-grow': {
    path: '',
    tags: ['textarea', 'resize'],
    internalOnly: false,
    stories: ['default'],
    description:
      'Directive to auto-grow or auto-resize textarea elements when typing',
  },
  'control-value-accessor': {
    path: '',
    tags: ['forms'],
    internalOnly: false,
    stories: ['default'],
    description:
      'Override the DefaultValueAccessor implementiation by supporting to set-up the cursor position after the super.writeValue(value); was called but before the valueChanges would be fired.',
  },
  hide: {
    path: '',
    tags: ['layout', 'text'],
    internalOnly: false,
    stories: ['default'],
    description:
      'Directive to hide/show elements based on the css media breakpoints',
  },
  'long-press': {
    path: '',
    tags: ['button', 'press'],
    internalOnly: false,
    stories: ['default'],
    description: 'Directive to handle long pressing elements',
  },
  repeat: {
    path: '',
    tags: ['layout', 'text'],
    internalOnly: false,
    stories: ['default'],
    description: 'Add the template content to the DOM `n` times.',
  },
  'scrolled-above-viewport': {
    path: '',
    tags: ['scroll', 'sticky', 'intersection observer', 'event'],
    internalOnly: false,
    stories: ['default'],
    description:
      "Directive to detect if the host element's place in the document has scrolled above the viewport.",
  },
  tagging: {
    path: '',
    tags: ['tag', 'text'],
    internalOnly: false,
    stories: ['default'],
    description:
      'Allows to track tagged user via @ key or general keywords via # key',
  },
  visibility: {
    path: '',
    tags: ['visibility', 'event'],
    internalOnly: false,
    stories: ['default'],
    description: 'Directive to detect if user has seen the DOM element.',
  },
};
